import DataStore from '@/engine/stores/data-store';

class WorkTrackerItemDataStore extends DataStore {

}

export default new WorkTrackerItemDataStore();
